import { currencyFormat } from '../../../../../helpers/utilities';

export const FEATURE = 'GST Recalculation';

/* Invoice numbers never contain spaces, so any run of commas, semicolons or whitespace separates them. */
export const splitSerialNos = (text) => (text || '').split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean);

/* Keeps the first spelling of each number; the server matches case-insensitively. */
export const uniqueSerialNos = (list) => {
    const seen = new Set();
    return list.filter((s) => {
        const key = s.toUpperCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};

export const serialNosKey = (list) => list.map((s) => s.toUpperCase()).sort().join('|');

export const STATUS = {
    CHANGED: { preview: 'Will change', saved: 'Updated', tone: 'changed' },
    UNCHANGED: { preview: 'No change', saved: 'No change', tone: 'neutral' },
    NOT_FOUND: { preview: 'Not found', saved: 'Not found', tone: 'warning' },
    FAILED: { preview: 'Failed', saved: 'Failed', tone: 'error' },
};

export const statusLabel = (status, dryRun) => STATUS[status]?.[dryRun ? 'preview' : 'saved'] || status;

export const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

export const money = (value) => (value === undefined || value === null ? '---' : `₹ ${currencyFormat(value)}`);

export const signedMoney = (value) => `${value > 0 ? '+' : value < 0 ? '−' : ''}₹ ${currencyFormat(Math.abs(value))}`;

export const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;

export const isDifferent = (before, after) =>
    before !== undefined && before !== null && after !== undefined && after !== null && round2(before) !== round2(after);

export const rateLabel = (gst) => {
    if (gst?.igstPercentage) return `IGST ${gst.igstPercentage}%`;
    if (gst?.cgstPercentage || gst?.sgstPercentage) return `CGST ${gst.cgstPercentage}% + SGST ${gst.sgstPercentage}%`;
    return 'No GST';
};

/* Counts per status, and the net GST / invoice amount movement across the results. */
export const summarise = (results) => {
    const counts = { ALL: results.length, CHANGED: 0, UNCHANGED: 0, NOT_FOUND: 0, FAILED: 0 };
    let gstDelta = 0;
    let amountDelta = 0;
    results.forEach((r) => {
        counts[r.status] = (counts[r.status] || 0) + 1;
        if (r.before && r.after) {
            gstDelta += (r.after.gstAmount ?? 0) - (r.before.gstAmount ?? 0);
            amountDelta += (r.after.invoiceAmount ?? 0) - (r.before.invoiceAmount ?? 0);
        }
    });
    return { counts, gstDelta: round2(gstDelta), amountDelta: round2(amountDelta) };
};
